import {Pipe, PipeTransform} from '@angular/core';
import {SectionStatisticsData} from "@dashboard/module/section-statistics/model";

@Pipe({
  name: 'dailySectionStats'
})
export class DailySectionStatsPipe implements PipeTransform {
  transform(stat:  SectionStatisticsData): number[] {
    const dateArray: [Date, number][] = Array.from(stat.countPerDate.entries());
    dateArray.sort((a, b) => a[0].getTime() - b[0].getTime());
    return  dateArray.map(([_, value]) => value);
  }
}
